import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

const useLogoutUser = () => {
  const { auth } = useDispatch<Dispatch>();
  const isEmbedded = useSelector(select.device.isEmbedded);

  return useCallback(() => {
    if (isEmbedded) {
      window.starsweb?.auth.logout();
      window.close();
    } else {
      auth.logout();
    }
  }, [auth, isEmbedded]);
};

export default useLogoutUser;
